import { render, staticRenderFns } from "./MasterAkses.vue?vue&type=template&id=10fa77ff&"
import script from "./MasterAkses.vue?vue&type=script&lang=js&"
export * from "./MasterAkses.vue?vue&type=script&lang=js&"
import style0 from "./MasterAkses.vue?vue&type=style&index=0&id=10fa77ff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports